import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { TEMPLATES_LIBRARY_TABS } from '../../../constants/template';
import { createNewTemplateRoute } from '../TemplatesLibraryPage';

import FileIcon from '../../../design-system/Icons/FileIcon';
import LayersIcon from '../../../design-system/Icons/LayersIcon';
import CircularIcon from '../../../design-system/CircularIcon/CircularIcon';
import PlayProcessIcon from '../../../design-system/Icons/PlayProcessIcon';
import { Button } from '../../../design-system';
import { AddCircleLineIcon } from '../../../design-system/Icons';

const EmptyIndexPage = ({ activeTab }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleNewTemplateClick = () => {
        navigate(createNewTemplateRoute[activeTab], {
            state: { templatesLibraryLocation: location },
        });
    };

    const label = {
        [TEMPLATES_LIBRARY_TABS.goals]: 'Goal',
        [TEMPLATES_LIBRARY_TABS.processes]: 'Process',
        [TEMPLATES_LIBRARY_TABS.playbooks]: 'Playbook',
    }[activeTab];

    const Icon = {
        [TEMPLATES_LIBRARY_TABS.goals]: FileIcon,
        [TEMPLATES_LIBRARY_TABS.processes]: LayersIcon,
        [TEMPLATES_LIBRARY_TABS.playbooks]: PlayProcessIcon,
    }[activeTab];

    return (
        <div className="flex flex-col py-[80px] items-center gap-4 self-stretch">
            <CircularIcon icon={Icon} />
            <div className="flex flex-col items-center gap-2">
                <p className="font-heading-bold text-heading-bold-m text-center">{`You don’t have any ${label} Templates yet.`}</p>
                <p className="font-body text-bold-m text-center">
                    Try creating one by clicking “New Template”
                </p>
            </div>
            <Button
                type="secondary"
                size="xs"
                text="New Template"
                leadingIcon={AddCircleLineIcon}
                onClick={handleNewTemplateClick}
            />
        </div>
    );
};

export default EmptyIndexPage;
